export function maskPhone(value) {
  var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+7 (___) ___-__-__';
  var masked = mask;
  var onlyDigits = value.replace(/\+7|\D/g, '');
  var lastDigit;
  onlyDigits.split('').forEach(function (digit) {
    if (masked.indexOf('_') > 0) {
      masked = masked.replace('_', digit);
      lastDigit = digit;
    }
  });
  return masked.slice(0, masked.lastIndexOf(lastDigit) + 1);
}
export var unformatPhone = function unformatPhone(value) {
  if (!value) return value;
  var onlyNumbers = value.replace(/\D/gi, '');
  return onlyNumbers.slice(onlyNumbers.length - 10, onlyNumbers.length);
};
export var formatFileSize = function formatFileSize(bytes) {
  var value = +bytes;
  if (Math.abs(value) < 1000) {
    return "".concat(value, " B");
  }
  var units = ['kB', 'MB', 'TB', 'PB'];
  var unitIndex = -1;
  do {
    value /= 1000;
    unitIndex++;
  } while (Math.abs(value) >= 1000 && unitIndex < units.length - 1);
  return "".concat(value.toFixed(1), " ").concat(units[unitIndex]);
};